import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersType } from '@cargos/sprintpay-models';
import { AuthGuard, CustomerTypeGuard } from 'src/app/shared/guards';
import { LoginComponent } from './pages/auth/login/login.component';
import { RecoverPasswordComponent } from './pages/auth/recover-password/recover-password.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { ConfirmationBDPComponent } from './pages/cart/confirmation-bdp/confirmation-bdp.component';
import { SearchAwbComponent } from './pages/search-awb/search-awb.component';

const routes: Routes = [
    {
        path: 'search-awb',
        pathMatch: 'full',
        component: SearchAwbComponent,
    },
    {
        path: 'cart',
        loadChildren: () => import('./pages/cart/cart.module').then((m) => m.CartBDPModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/payment-method',
        loadChildren: () =>
            import('./pages/cart/guest-payment-method-component/guest-payment-method.module').then(
                (m) => m.GuestPaymentMethodBDPModule
            ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/confirmation',
        component: ConfirmationBDPComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            expectedCustomerTypes: [CustomersType.GUEST, undefined, CustomersType.SALESFORCE_AUTHENTICATED],
            hideTitle: true,
        },
        canActivate: [CustomerTypeGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
    },
    {
        path: '**',
        redirectTo: 'search-awb',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
        }),
    ],
    exports: [RouterModule],
})
export class BdpRoutingModule {}
